var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#fff",
    d: "M 43.5,-0.5 C 113.833,-0.5 184.167,-0.5 254.5,-0.5C 277.714,3.20928 292.214,16.5426 298,39.5C 298.667,112.5 298.667,185.5 298,258.5C 293.384,280.783 279.884,293.95 257.5,298C 185.167,298.667 112.833,298.667 40.5,298C 17.6542,293.654 3.9875,280.154 -0.5,257.5C -0.5,185.167 -0.5,112.833 -0.5,40.5C 5.19111,17.1405 19.8578,3.47386 43.5,-0.5 Z M 47.5,15.5 C 115.501,15.3333 183.501,15.5 251.5,16C 268.323,17.8247 278.49,26.9914 282,43.5C 282.667,114.167 282.667,184.833 282,255.5C 278.267,270.567 268.767,279.401 253.5,282C 183.833,282.667 114.167,282.667 44.5,282C 28.3333,279.167 18.8333,269.667 16,253.5C 15.3333,183.833 15.3333,114.167 16,44.5C 19.378,26.9507 29.878,17.284 47.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#fff",
    d: "M 141.5,48.5 C 172.41,47.8997 190.577,62.8997 196,93.5C 197.436,109.057 196.269,124.39 192.5,139.5C 190.446,144.176 188.112,148.676 185.5,153C 185.957,153.414 186.291,153.914 186.5,154.5C 179.778,165.907 170.445,174.574 158.5,180.5C 154.712,181.677 150.879,182.677 147,183.5C 138.458,182.576 130.624,179.576 123.5,174.5C 118.438,169.775 113.772,164.775 109.5,159.5C 106.911,153.017 103.911,146.35 100.5,139.5C 96.4835,123.205 95.4835,106.705 97.5,90C 102.822,65.8346 117.488,52.0013 141.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.169
    },
    fill: "#fff",
    d: "M 100.5,171.5 C 98.3736,170.952 96.3736,170.285 94.5,169.5C 95.9179,167.692 97.9179,167.025 100.5,167.5C 100.5,168.833 100.5,170.167 100.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.147
    },
    fill: "#fff",
    d: "M 198.5,169.5 C 196.735,170.461 194.735,170.795 192.5,170.5C 192.5,169.5 192.5,168.5 192.5,167.5C 195.082,167.025 197.082,167.692 198.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#fff",
    d: "M 94.5,169.5 C 96.3736,170.285 98.3736,170.952 100.5,171.5C 104.146,174.151 107.146,177.485 109.5,181.5C 113.141,183.81 116.474,186.477 119.5,189.5C 119.402,192.248 120.402,192.914 122.5,191.5C 124.576,192.647 126.576,193.981 128.5,195.5C 129.167,195.167 129.833,194.833 130.5,194.5C 141.167,199.833 151.833,199.833 162.5,194.5C 163.167,194.833 163.833,195.167 164.5,195.5C 171.086,191.112 177.419,186.445 183.5,181.5C 186.167,177.505 189.167,173.839 192.5,170.5C 194.735,170.795 196.735,170.461 198.5,169.5C 202.671,170.886 206.671,172.719 210.5,175C 211.126,175.75 211.626,176.584 212,177.5C 212.333,177.167 212.667,176.833 213,176.5C 225.403,185.568 235.736,195.902 244,207.5C 247.084,214.419 247.917,221.585 246.5,229C 243.838,234.171 239.838,237.671 234.5,239.5C 234.44,238.957 234.107,238.624 233.5,238.5C 232.15,239.95 230.484,240.617 228.5,240.5C 228.5,241.5 228.5,242.5 228.5,243.5C 220.284,245.59 211.617,246.923 202.5,247.5C 160.452,250.391 118.452,249.891 76.5,246C 75.4542,244.461 74.1209,244.295 72.5,245.5C 43.3465,238.436 37.6799,222.769 55.5,198.5C 66.0013,186.521 78.0013,177.354 91.5,171C 91.1667,170.667 90.8333,170.333 90.5,170C 91.7932,169.51 93.1266,169.343 94.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.586
    },
    fill: "#fff",
    d: "M 119.5,189.5 C 121.179,189.285 122.179,189.952 122.5,191.5C 120.402,192.914 119.402,192.248 119.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32
    },
    fill: "#fff",
    d: "M 234.5,239.5 C 234.611,240.117 234.944,240.617 235.5,241C 232.969,241.448 230.636,242.281 228.5,243.5C 228.5,242.5 228.5,241.5 228.5,240.5C 230.484,240.617 232.15,239.95 233.5,238.5C 234.107,238.624 234.44,238.957 234.5,239.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.058d7381a62e85849a343eed16a6049a.svg";
export { ForwardRef as ReactComponent };